<template>
    <div id="tipoSelect">
        <select
            ref="tipoTarefa"
            :value="value.tipoTarefa"
            @change="updateTipo($event.target.value)">
            <option value="" disabled selected>Selecione...</option>
            <option v-for="op in options"
                    :value="op.value">{{ op.text }}
            </option>
        </select>
        <label>{{ label }}</label>
    </div>
</template>

<script>
    export default {
        data: () => ({
            tipo: "",
            label: "Tipo",
            options: [
                {value: 1, text: "Visita"},
                {value: 2, text: "Reunião"},
                {value: 3, text: "Atividade"},
                {value: 4, text: "Almoço"},
            ],
        }),
        props: ['value'],
        methods: {
            updateTipo(value) {
                // console.log(value);
                this.$emit('select', value);
            }
        },
        mounted() {
            $(this.$refs.tipoTarefa).material_select()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/TipoSelect.vue